import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { SessionService } from './../_shared/session/session.service';
import { PessoaService } from './../_shared/pessoa/pessoa.service';
import { HeaderService } from '../_shared/http/header.service';
import { Pessoa } from './../_shared/pessoa/pessoa';

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.css']
})

export class InicioComponent implements OnInit {

  public pessoa: Pessoa = new Pessoa();
  public primeiroNome: string;

  constructor(private router: Router,
    private PessoaService: PessoaService,
    private SessionService: SessionService,
    private HeaderService: HeaderService) { }

  ngOnInit() {

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

    this.pessoa = this.PessoaService.getPessoa();

    if (this.pessoa.pes_nom) {
      this.primeiroNome = this.pessoa.pes_nom.split(' ')[0];
    }

    this.HeaderService.getTokenGnx().subscribe(data => data, err => err);

  }

  proximo() {
    this.router.navigate(['/curso']);
  }

}



// WEBPACK FOOTER //
// ./src/app/inicio/inicio.component.ts